module.exports = __webpack_public_path__ + "img/Dia de campo 1.c8239ed6.webp";